/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (stringResources, ContentActionsProviderAPI, APIFactory) => {

	class SwapRowColumnAction {
		constructor(features) {
			this._features = features;
		}

		getContentActionList(idList) {
			let contribution = [];
			if (this._getSelectedContent(idList)) {
				const contentId = idList[0];
				const content = this._features['Canvas'].getContent(contentId);
				const visualization = content.getFeature('Visualization');
				const swapIcon = this._features['Icons'].getIcon('dashboard-swap');
				if (this._supportAction(content)) {
					contribution = [{
						name: 'swapRowsAndColumns',
						label: stringResources.get('swapRowsAndColumns'),
						icon: swapIcon.id,
						section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_VIZ_FORMAT,
						order: 10,
						actions: {
							apply: this.swapRowsAndColumns.bind(this, visualization)
						},
						type: 'Button'
					}];
				}
			}

			return contribution;
		}

		swapRowsAndColumns(visualization) {
			visualization.getSlots().swapSlots('column_level1', 'row_level1');
		}

		_supportAction(content) {
			let isAllowed = false;
			const uiState = this._features['DashboardState'].getUiState();
			const visualization = content.getFeature('Visualization');
			if (visualization && !uiState.eventGroups) {
				let visId = visualization.getDefinition().getId();
				let mappingComplete = visualization.getSlots().isMappingComplete();

				isAllowed = mappingComplete && visId === 'crosstab';
			}

			return isAllowed;
		}

		_getSelectedContent(idList) {
			return idList.length === 1;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}
	}

	return SwapRowColumnAction;
});
